import type { TradingPartnerContactEntry } from '@ebalance/proto/bffuser/v1/occto_master_model_pb'

/**
 * 連絡先モーダルの「担当者名」欄の表示値。部署名と担当者名を ` / ` で連結し、
 * 片方が空ならもう片方だけ、両方空なら undefined (呼び出し側が「—」を出す)。
 * mock-app `PlanSubmissionDiagram.razor.cs::GetContactInfo` の `Map` と同じ連結。
 */
export function formatContactPerson(
  entry: Pick<TradingPartnerContactEntry, 'department' | 'name'>,
): string | undefined {
  const parts = [entry.department, entry.name ?? ''].filter((s) => s !== '')
  return parts.length === 0 ? undefined : parts.join(' / ')
}
